export const i18nGetLocalizedString = (localeObject: object, defaultKey: string = 'i18n_string_en') => {
  if (!localeObject) return null

  return localeObject?.current_locale?.trim() || localeObject[defaultKey]?.trim()
}
